import React, { FC, useEffect, useState } from "react";
import Input from "../customhtmlcomponents/Input";
import Button from "../customhtmlcomponents/Button";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { ResponseData } from "../adminpanel/panels/types/types";
import { URLS } from "../../utility/UrlConstants";
import axios from "../../services/ApiConfig";
import { AxiosResponse } from "axios";
import NavigationBar from "../NavigationBar";
import {
  IntlNubmerFormatter,
  mapObjectFieldsToInt,
} from "../../utility/formatInputField";
import {
  lokalforeningTemplate1,
  lokalforeningTemplate2,
  medlemsinformasjonTemplate,
} from "./LokalforeningTemplate";
import getRapportAar from "../../utility/dateUtils";
import FooterButtons from "../customhtmlcomponents/FooterButtons";

interface LokalForeningsProps {
  currentForeningReportNumber: number;
  username: string;
  message: React.Dispatch<React.SetStateAction<{ body: ResponseData }>>;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type State = {
  foreningsNummer: number;
  fylke: string;
  kommune: string;
  organisasjonsNummer: string | number;
  foreningsNavn: string;
  kontoNummer: string | number;
  facebookReferanse: string;
  epost: string;
  webAdresse: string;
  antallMedlemmer: number | string;
  antallBetalendeMedlemmer: number | string;
  antallNyeMedlemmerSisteAr: number | string;
  antallUtmeldteMedlemmerSisteAr: number | string;
  gjennomsnittsAlder: number | string;
  isButtonDisabled: boolean;
  helperText: string;
  isError: boolean;
};

const initialState: State = {
  foreningsNummer: 0,
  fylke: "",
  kommune: "",
  organisasjonsNummer: "",
  foreningsNavn: "",
  kontoNummer: 0,
  facebookReferanse: "",
  epost: "",
  webAdresse: "",
  antallMedlemmer: "",
  antallBetalendeMedlemmer: "",
  antallNyeMedlemmerSisteAr: "",
  antallUtmeldteMedlemmerSisteAr: "",
  gjennomsnittsAlder: "",
  isButtonDisabled: false,
  helperText: "",
  isError: false,
};

const LokalForening: FC<LokalForeningsProps> = ({
  currentForeningReportNumber,
  username,
  message,
  setModal,
}: LokalForeningsProps) => {
  const { register, setValue, handleSubmit, errors, getValues } =
    useForm<State>();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lokalforening1, setLokalforening1] = useState(lokalforeningTemplate1);
  const [lokalforening2, setLokalforening2] = useState(lokalforeningTemplate2);
  const [medlemsinformasjon, setMedlemsinformasjon] = useState(
    medlemsinformasjonTemplate
  );
  const [stateForeningsNummer, setForeningNummer] = useState(
    currentForeningReportNumber
  );
  const history = useHistory();
  const [rapportAar, setRapportAar] = useState();
  const saveOnClick = async (e: React.BaseSyntheticEvent, link: string) => {
    e.preventDefault();
    handleNavBarClick().then(() => history.push(link));
  };

  const saveSuccessMessage = () => {
    message({
      body: {
        body: {
          message: "Lokalforening ble lagret.",
        },
      },
    });
    //calls setModal to render modal in App.tsx
    setModal(true);
    //removes rendering of modal in App.tsx
    setTimeout(() => setModal(false), 4000);
  };

  const postFormData = async (getValues: any, redirectToNextPage: boolean) => {
    setIsSubmitting(true);
    const obj = prepareValuesForPost(getValues);
    axios
      .post(URLS.LOKALFORENING_POST, obj)
      .then((response: AxiosResponse) => {
        console.log(response.data);

        saveSuccessMessage();

        if(redirectToNextPage){
          setTimeout(() =>
            {
              setIsSubmitting(false);
              history.push({
              pathname: "/styret",
              state: currentForeningReportNumber,
              })
            },
            1750
          );
        }
      })
      .catch((error) => {
        console.log(error?.response?.data);
        message({
          body: {
            body: {
              error: "Dessverre feilet lagring av Lokalforening. Vennligst sjekk at alle felter er fylt inn med rett verdi og prøv igjen.",
            },
          },
        });
        setModal(true);
        setTimeout(() => {
          setModal(false)
          setIsSubmitting(true);
        }, 5000);
      });
  }

  const handleNavBarClick = handleSubmit(async (getValues) => {
    postFormData(getValues, false);
  });

  function prepareValuesForPost<TSubmitFieldValues>(getValues: any) {
    const {
      antallMedlemmer,
      antallBetalendeMedlemmer,
      antallNyeMedlemmerSisteAr,
      antallUtmeldteMedlemmerSisteAr,
      gjennomsnittsAlder,
      ...rest
    } = getValues;
    let integerValues = {
      antallMedlemmer,
      antallBetalendeMedlemmer,
      antallNyeMedlemmerSisteAr,
      antallUtmeldteMedlemmerSisteAr,
      gjennomsnittsAlder,
    };
    mapObjectFieldsToInt(integerValues);

    const obj = {
      ...rest,
      ...integerValues,
      foreningsNummer: currentForeningReportNumber,
    };
    return obj;
  }

  const submitLokalForening = handleSubmit((getValues) => {
    postFormData(getValues, true);
  });
  const location = useLocation();

  useEffect(() => {
    console.log(currentForeningReportNumber);
    setValue("foreningsNummer", currentForeningReportNumber);

    async function getLokalForening() {
      const response = await axios.get(
        `${URLS.LOKALFORENING_GET}${currentForeningReportNumber}`,
        {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
          },
        }
      );
      console.log(response);
      setValue("fylke", response.data.fylke);
      setValue("kommune", response.data.kommune);
      setValue("organisasjonsNummer", response.data.organisasjonsNummer);
      setValue("foreningsNavn", response.data.foreningsNavn);
      setValue("kontoNummer", response.data.kontoNummer);
      setValue("facebookReferanse", response.data.facebookReferanse);
      setValue("epost", response.data.epost);
      setValue("webAdresse", response.data.webAdresse);
      setValue(
        "antallMedlemmer",
        IntlNubmerFormatter(response.data.antallMedlemmer)
      );
      setValue(
        "antallBetalendeMedlemmer",
        IntlNubmerFormatter(response.data.antallBetalendeMedlemmer)
      );
      setValue(
        "antallNyeMedlemmerSisteAr",
        IntlNubmerFormatter(response.data.antallNyeMedlemmerSisteAr)
      );
      setValue(
        "antallUtmeldteMedlemmerSisteAr",
        IntlNubmerFormatter(response.data.antallUtmeldteMedlemmerSisteAr)
      );
      setValue("gjennomsnittsAlder", response.data.gjennomsnittsAlder);
      setRapportAar(response.data.rapportAar);
    }

    console.log(getValues());
    getLokalForening().catch((errors) => console.error(errors));
  }, [isLoading, currentForeningReportNumber, location.state, setValue]);
  const isAdmin = username === "1";
  const adminStyle = isAdmin ? "" : "bg-gray-200";
  // @ts-ignore
  return (
    <>
      <NavigationBar saveOnClick={saveOnClick} />
      <div className="bg-sk-tertiary-red pb-40">
        <form onSubmit={submitLokalForening}>
          <h1 className="font-sans font-bold text-2xl text-center">
            1. Lokalforening og medlemsinformasjon
          </h1>
          <div className="flex flex-col items-center mx-auto transform scale-75">
            {/* Main header */}

            {/* Main wrapper for containers */}
            <div className="flex flex-col place-content-center w-full space-y-8 ">
              {/*Container 1*/}
              <div
                className="mx-auto justify-items-stretch pt-10 pb-10 w-2/3 shadow-lg
                        bg-sk-button-selected border-2 border-sk-secondary-blue overflow-hidden rounded p-5"
              >
                <p className="font-sans font-bold text-center text-2xl pb-5">
                  1.1 Lokalforening
                </p>
                <table className="mt-8 table table-auto">
                  <tbody>
                    <tr className="text-lg text-center space-x-4 border-b border-sk-tertiary-blue">
                      <td>Foreningsnummer:</td>
                      <td>
                        <strong className="text-shadow-active">
                          {currentForeningReportNumber + " "}{" "}
                        </strong>
                        {/*Content (Input) 1*/}
                        (Rapport sist levert:
                        {rapportAar
                          ? rapportAar
                          : " Ikke levert for " + getRapportAar}
                        )
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="grid xl:grid-cols-2 gap-4 pt-10 grid-cols-1">
                  <table className="table table-auto">
                    <tbody>
                      {lokalforening1.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            className="border-b border-sk-tertiary-blue"
                          >
                            <td className="whitespace-nowrap pl-2 pr-2 border-sk-tertiary-blue text-left text-medium font-medium">
                              {item.text}
                            </td>
                            <td className="text-xl font-thin p-2 cursor-pointer justify-end border-sk-tertiary-blue">
                              <Input
                                className="text-medium text-left font-thin pr-2 w-full"
                                type={item.type ?? "text"}
                                name={item.name}
                                ref={register}
                                id={item.name}
                                label={item.name}
                                labelopts={{
                                  defaultLabelStyle: false,
                                  labelOn: false,
                                }}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <table className="table table-fixed">
                    <tbody>
                      {lokalforening2.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            className="border-b border-sk-tertiary-blue"
                          >
                            <td className="whitespace-nowrap pl-2 pr-2 border-sk-tertiary-blue text-left text-medium font-medium">
                              {item.text}
                            </td>
                            <td className="text-center text-xl font-thin p-2 cursor-pointer justify-end border-sk-tertiary-blue">
                              <Input
                                className="text-medium font-thin  text-left pr-2 w-full"
                                type={item.type ?? "text"}
                                name={item.name}
                                ref={register}
                                id={item.name}
                                label={item.name}
                                labelopts={{
                                  defaultLabelStyle: false,
                                  labelOn: false,
                                }}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              {/*Container 2*/}
              <div
                className="flex flex-col mx-auto justify-items-center pb-10 w-2/3 shadow-lg
                        bg-sk-button-selected border-2 border-sk-secondary-blue overflow-hidden rounded p-5"
              >
                <p className="font-sans font-bold text-left text-2xl mt-5 pt-10 pb-5">
                  1.2 Medlemsinformasjon
                </p>
                <p className="font-sans text-left text-xl mt-2 pb-5">
                  Medlemsinformasjon legges inn av administrasjonen sentralt og
                  kan ikke endres av lokalforeningen.
                </p>
                {/*Content (Input) 2*/}
                <table className="table table-fixed pt-10">
                  <tbody>
                    {medlemsinformasjon.map((item, index) => {
                      return (
                        <tr
                          key={index}
                          className="border-b border-sk-tertiary-blue"
                        >
                          <td className="whitespace-nowrap pl-2 pr-2 text-left text-medium font-medium">
                            {item.text}
                          </td>
                          <td className="text-center text-xl font-thin p-2 cursor-pointer justify-end">
                            <Input
                              className={`text-center text-medium font-thin  text-right pr-2 w-2/3 ${adminStyle}`}
                              type="text"
                              maxLength={5}
                              name={item.name}
                              ref={register}
                              id={item.name}
                              label={item.name}
                              labelopts={{
                                defaultLabelStyle: false,
                                labelOn: false,
                              }}
                              isNumberField={true}
                              readOnly={!isAdmin}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/*This is the buttons at the bottom of the page, only LAGRE OG GÅ VIDERE on this page*/}
          <FooterButtons previousLocation="/lokalforening" saveOnClick={saveOnClick} hidePreviousButton isSubmitting={isSubmitting}/>
        </form>
      </div>
    </>
  );
};

export default LokalForening;
